<template>
  <ConfigurablePage page-identifier="market_overview" />
</template>

<script>
import ConfigurablePage from '@/components/ConfigurablePage.vue'

export default {
  name: 'Overview_List_Engage',
  components: {
    ConfigurablePage
  }
}
</script>
